import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreLocation } from '../../../../shared/models/storeLocation';
import { State, STATES } from '../../../../shared/models/state';
import { StoreLocationService } from '../../../../shared/services/storelocation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationService } from '../../../services/validation.service';

@Component({
  selector: 'app-location-add-form',
  templateUrl: './location-add.component.html'
})

export class LocationAddFormComponent implements OnInit { 

  //input/output parameters
  @Input() title;
  @Input() brandId: number; 
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  addForm : FormGroup; 
  submitted = false;
  public stateList: State[] = STATES;  // bind list of states

  constructor(private formBuilder: FormBuilder, public activeModal: NgbActiveModal, private storeLocationService: StoreLocationService, private notification: MatSnackBar) { }

  // on component load
  ngOnInit() { 
    this.addForm = this.formBuilder.group({
      brandId: [this.brandId, Validators.required],
      storeId: [''],
      name: ['', Validators.required],
      address1: ['', Validators.required],
      address2: [''],
      city: ['', [Validators.required, ValidationService.alphaNumericSpecialCharactersValidator]],
      state: ['', Validators.required],
      zipCode: ['', [Validators.required, ValidationService.zipCodeValidator]],
      email: ['', Validators.email],
      phone: ['', ValidationService.phoneValidator],
      hours: [''],
      url: ['', ValidationService.urlValidator]
    });
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.addForm.invalid) {
        return; 
      } 

      this.storeLocationService.add(this.addForm.value as StoreLocation).subscribe(storeLocation => {       
        this.eventEmitter.emit(this.addForm.value);
        this.activeModal.close(storeLocation);
        this.showNotification(`The new store location ${storeLocation.name} was successuly added!`, 'Okay!') 
      });
     
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
